export interface ApiResponse<T> {
    data: T;
    status: number;
    success: boolean;
}

export enum FetchResultType {
    Error = 'error',
    Success = 'success',
}

export interface SuccessfulFetchResult<T> {
    status: number;
    type: FetchResultType.Success;
    data: T;
}

export interface UnsuccessfulFetchResult<E> {
    status: number;
    type: FetchResultType.Error;
    error: E;
}

export type FetchResult<T, E> = SuccessfulFetchResult<T> | UnsuccessfulFetchResult<E>;

export const isFetchResultSuccessful = <T, E>(result: FetchResult<T, E>): result is SuccessfulFetchResult<T> => (
    result.type === FetchResultType.Success
);
